import ImagePreview from './src/main.js'
export default ImagePreview
